export default "__VITE_ASSET__16pYSBIQ__"